import { useTranslation } from "react-i18next";

export default function FeaturesSection() {
  const { t } = useTranslation("home");
  const features = t("features", { returnObjects: true }) as string[];

  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-12">
          {t("featuresTitle")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feat: string, i: number) => (
            <div
              key={i}
              className="flex items-start gap-3 p-5 bg-background-100 rounded-xl"
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-primary-100">
                <i className="ri-star-line text-primary-600 text-sm"></i>
              </div>
              <span className="text-sm text-foreground-700 leading-relaxed pt-1">
                {feat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}